import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../components/OverlayLoader';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AlertModal from '../../components/Tests/components/AlertModal';
import { sha256Encode } from '../../utils/generals';

import { showToast } from '../../utils/toast';
import { base64Decode } from '../../utils/generals';
import HttpClient from '../../helpers/HttpClient'; 

export default function Activate() {
  const [open, setOpen] = React.useState(false);
  const [showModalPwd, setShowModalPwd] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [ready, setReady] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pwd, setPwd] = React.useState({
    new: '',
    newr: ''
  });
  const [confirmCode, setConfirmCode] = React.useState('');
  const [confirmCode2, setConfirmCode2] = React.useState('');

  const confirmCodeResult = async() => {
    if (sha256Encode(confirmCode2) == confirmCode) {
      
      if (pwd.new == '' || pwd.newr == ''){
        showToast('Nueva contraseña no válida.');
        
      } else {
        if (pwd.new != pwd.newr) {
          showToast('Las contraseñas deben coincidir.');
        } else {
          setOpen(true);
          const response = await HttpClient().put(`/user/update-password`,{
            userId: email,
            code: confirmCode2,
            password: pwd.new
          });

          if (response.error) {
            setOpen(false);
            showToast(
              'No fue posible actualizar tu contraseña. Intenta nuevamente.',
              'error'
            );
          } else {
            showToast(
              'Contraseña actualizada correctamente. Da click en el botón o cierre el mensaje para ir a la pantalla de inico de sesión',
              'success',
              undefined,
              () => {
                navigate('/login');
              }
            );
          }
        }
      }

    }else{
      showToast('Código de confirmación no válido.');
    }
  }

  const requestCode = async (email) => {
    setOpen(true);
    const response = await HttpClient().post(`/mailing/recovery-password`,{
      userId: email
    });
    if (response.error) {
      setOpen(false);
      showToast(
        'No fue posible enviar tu correo de confirmación. Intenta nuevamente.',
        'error'
      );
    } else {
      setOpen(false);
      const data = response.data;
      if (data.ok) {
        setEmail(email);
        setConfirmCode(data.ok);
      } else {
        showToast(
          'No fue posible continuar con el proceso. Intenta nuevamente.',
          'error'
        );
      }
    }
  };


  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email').trim();
    if (email == '') {
      showToast('Digita un correo válido');
    } else {
      setOpen(true);
      requestCode(email);
    }
  };

  return (
    <Container component="main" maxWidth="xs" className='container-center'>
      <OverlayLoader
        open={open}
        ready={ready}
        buttonClick={() => {
          setOpen(false);
          navigate('/login');
        }}
      />
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        className='login-center'
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Recuperar contraseña
        </Typography>
        <Typography
          sx={{ marginTop: 2, marginBottom: 2 }}
          component="h1"
          variant="body2"
        >
          Digita el correo suministrado cuando te registraste
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo electrónico"
            name="email"
            autoComplete="off"
            autoFocus
          />
           {confirmCode ? (
            <><TextField
            margin="normal"
            required
            fullWidth
            id="code"
            label="Código"
            name="code"
            autoComplete="off"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setConfirmCode2(event.target.value);
            }}
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="newpassword"
            label="Nueva contraseña"
            name="newpassword"
            autoComplete="off"
            type="password"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPwd({
                ...pwd,
                new: event.target.value
              });
            }}
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="newpasswordr"
            type="password"
            label="Nueva contraseña"
            name="newpasswordr"
            autoComplete="off"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPwd({
                ...pwd,
                newr: event.target.value
              });
            }}
            autoFocus
          /></>
           ):(null)}
          {confirmCode ? (
            <Button
              type="button"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={()=>{
                confirmCodeResult()
              }}
            >
              Recuperar Contraseña
            </Button>
          ) : null}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {!confirmCode ? 'Enviar correo' : 'Volver a enviar correo'}
          </Button>
          <Grid container sx={{textAlign: "center"}}>
            <Grid item xs>
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  navigate('/login');
                }}
              >
                Volver
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/*<ToastContainer />*/}
      {/*<AlertModal
          open={showModalPwd}
          title={''}
          content={<>
             <Typography variant="subtitle1" gutterBottom>
              Tu contraseña es:
            </Typography>
            <Typography variant="h6" gutterBottom>
             {base64Decode(pwd)}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
             Te recomendamos realizar el cambio de la misma una vez inicies sesión.
            </Typography>
            </>}
          buttonText={'Ir a iniciar sesión'}
          onButtonClick={() => {
            navigate("/login")
          }}
        />*/}
    </Container>
  );
}
